import React from 'react'

export default function GotoTop() {
    return (
        
            <div className="gototop js-top">
					<a href="#" class="js-gotop"><i class="fa fa-arrow-up" aria-hidden="true"></i></a>
				</div>
        
    )
}
